import { Pipe, PipeTransform } from "@angular/core";
import { CustomerTaxCategory, PaymentMethod } from "../model";
import { TranslateService } from "@ngx-translate/core";

@Pipe({
    standalone: true,
    name: 'paymentMethod',
    pure: true
})
export class PaymenMethodPipe implements PipeTransform {

    constructor(protected translateService: TranslateService) {

    }

    transform(value: PaymentMethod): string {
        switch (value) {
            case PaymentMethod.BankAcount:
                return "IBAN"
            case PaymentMethod.CreditCard:
                return "Card";
        }

        return '-';
    }


}
